module.exports = __webpack_public_path__ + "static/img/8.cc735ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/snip3down/8.png
// module id = K3UD
// module chunks = 35